import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getTokenRole, hasActiveAuthSession, normalizeRole } from "../../utils/authUtils";

export default function PublicRoute() {
    const token = localStorage.getItem("token");
    const hasSession = hasActiveAuthSession();
    const role = normalizeRole(localStorage.getItem("role"));
    const tokenRole = getTokenRole(token || "");
    const effectiveRole = role || tokenRole;

    if (token && hasSession) {
        // Redirect to appropriate dashboard based on role
        const dashboardPath =
            effectiveRole === "admin" ? "/admindashboard" :
                effectiveRole === "teacher" ? "/teacherdashboard" :
                    effectiveRole === "headteacher" ? "/headteacher" :
                        "/dashboard";

        return <Navigate to={dashboardPath} replace />;
    }

    return <Outlet />;
}







